<template>
  <div class="content">
    <el-row class="content-top">
      <el-col :span="5" class="record-name">{{name}}</el-col>
      <el-col :span="19" style="height: 100%;line-height: 1rem">
        <span class="record-h">就诊卡号&nbsp{{mzh?mzh:'000000'}}</span>
      </el-col>
    </el-row>
<!--    <el-row class="content-line">-->
<!--      <el-col :span="8" class="title">就诊院区</el-col>-->
<!--      <el-col :span="14" class="text">怀化市第一人民医院</el-col>-->
<!--    </el-row>-->
    <el-row class="content-line">
      <el-col :span="8" class="title">就诊科室</el-col>
      <el-col :span="14" class="text">{{ks}}</el-col>
    </el-row>
    <el-row class="content-line">
      <el-col :span="8" class="title">就诊医生</el-col>
      <el-col :span="14" class="text">{{doctor}}</el-col>
    </el-row>
    <el-row class="content-line">
      <el-col :span="8" class="title">预约日期</el-col>
      <el-col :span="14" class="text">{{date}}</el-col>
    </el-row>
    <el-row class="content-line">
      <el-col :span="8" class="title">预约时间</el-col>
      <el-col :span="14" class="text">{{dated}}</el-col>
    </el-row>
    <el-row class="content-line">
      <el-col :span="8" class="title">预约流水</el-col>
      <el-col :span="14" class="text">{{orderId}}</el-col>
    </el-row>
    <el-row class="content-line">
      <el-col :span="8" class="title">预约挂号</el-col>
      <el-col :span="14" class="text">￥{{price}}</el-col>
    </el-row>
    <el-row class="content-line">
      <el-col :span="8" class="title">支付状态</el-col>
      <el-col :span="14" class="text" style="color: #999">{{payStatus==0?'未支付':'已支付'}}</el-col>
    </el-row>
    <el-row class="content-line" v-if="refund_status">
      <el-col :span="8" class="title">订单退款</el-col>
      <el-col :span="14" class="text" style="color: red">有退款</el-col>
    </el-row>
    <el-row class="content-line" v-if="his_returnmsg">
      <el-col :span="8" class="title">退款原因</el-col>
      <el-col :span="14" class="text" style="overflow: hidden;text-overflow: ellipsis;white-space: nowrap;">{{his_returnmsg}}</el-col>
    </el-row>
    <el-row class="content-line"  v-if="status==1">
      <el-col :span="8" class="title">订单状态</el-col>
      <el-col :span="14" class="text" style="color: red">已取消</el-col>
    </el-row>
    <div style="text-align: center;margin-top: .4rem">
      <el-button type="primary" size="small" style="width: 4rem;" @click="toAnswerDetails">新冠问卷详情</el-button>
    </div>
    <div style="text-align: center;margin-top: .4rem" v-if="status==0">
      <el-button type="warning" size="small" style="width: 4rem;" @click="qxyy">取消预约</el-button>
    </div>
  </div>
</template>

<script>
  import {getguahaodetail,yyguahaoTk,cancelYy} from '../../api/index'
    export default {
      data(){
        return{
          name:'',
          mzh:'',
          ks:'',
          doctor:'',
          date:'',
          dated:'',
          orderId:'',
          price:'',
          payStatus:0,
          his_returncode:'',
          status:0,
          refund_status:'',
          his_returnmsg:'',
          crown_time:'',
          patientId:''
        }
      },
      created() {
        //修改标题
        document.title = '预约挂号记录'
        getguahaodetail({
          orderid:this.$route.query.orderId
        }).then(res=>{
          this.name = res.Data.clinic_patient_name
          this.mzh = res.Data.clinic_card_num
          this.ks = res.Data.dept_name
          this.doctor = res.Data.doc_name
          this.date = res.Data.num_source_date
          this.dated = res.Data.time_period
          this.orderId = res.Data.order_id
          this.price = res.Data.price
          this.payStatus = res.Data.pay_status
          this.his_returncode = res.Data.his_returncode
          this.status = res.Data.status
          this.refund_status = res.Data.refund_status
          this.his_returnmsg = res.Data.his_returnmsg?res.Data.his_returnmsg:res.Data.cancle_msg
          this.crown_time = res.Data.crown_time
          this.patientId = res.Data.PatientId
        })
      },
      methods:{
        sqtk(){
          yyguahaoTk({
            order_id:this.$route.query.orderId
          }).then(res=>{
            if(res.IsSuccess){
              this.$message({
                type: 'success',
                message: '申请退款成功！',
                duration:3000,
                offset:200
              });
              this.$router.push({path:'/registrationRecord'})
            }else {
              this.$message({
                type: 'error',
                message: res.Msg,
                duration:3000,
                offset:200
              });
            }
          })
        },
        qxyy(){
          cancelYy({
            orderid:this.$route.query.orderId
          }).then(res=>{
            if(res.IsSuccess){
              this.$message({
                type: 'success',
                message: '取消预约成功！',
                duration:3000,
                offset:200
              });
              this.$router.push({path:'/registrationRecord'})
            }else {
              this.$message({
                type: 'error',
                message: res.Msg,
                duration:3000,
                offset:200
              });
            }
          })
        },
        //跳转新冠问卷详情
        toAnswerDetails(){
          this.$router.push({path:'/answerDetails',query:{time:this.crown_time,patientId:this.patientId}})
        }
      }
    }
</script>

<style scoped>
  .content{
    width: 100%;
    height: 100vh;
    font-size: .28rem;
    background-color: #f5f5f5;
  }
  .content-top{
    height: 1rem;
    background-color: #FFFFFF;
    border-bottom: 2px #dddddd solid;
  }
  .record-name{
    text-align: center;
    color: #666666;
    height: 100%;
    line-height: 1rem;
  }
  .record-h{
    color: #409eff;
    border: 1px #409eff solid;
    border-top-left-radius: .2rem;
    border-bottom-right-radius: .2rem;
    padding: .02rem .18rem;
  }
  .content-line{
    height: .8rem;
    background-color: #FFFFFF;
  }
  .title{
    line-height: .8rem;
    margin-left: .3rem;
    color: #666666;
  }
  .text{
    line-height: .8rem;
    text-align: right;
  }
  .content-ewm{
    line-height: .8rem;
    height: .8rem;
    border-top: 1px #dddddd solid;
    border-bottom: 1px #dddddd solid;
    background-color: #FFFFFF;
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/registrationRecordDetails.vue